export default "__VITE_ASSET__D5U9YNHv__"